import {nextTick, watch} from "vue";


export function useEditableFocus(isEditing, inputRef) {
    watch(isEditing, async (editing) => {
        if (editing) {
            await nextTick();

            // Works for native inputs and components that expose a `focus()` method
            const el = inputRef.value;
            if (el && typeof el.focus === 'function') {
                el.focus();
            }
        }
    });
}
